import {
  ServiceProvider,
  ClientType,
  CredentialEntity,
  ExchangeAuthCodeFnReq,
  ExchangeAuthCodeFnRes,
} from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';
import { ExchangeAuthCodeInteractor } from '../../auth/domain/interactors/exchange-auth-code.interactor';

export class ExchangeGoogleAuthCodeInteractor implements ExchangeAuthCodeInteractor {
  private readonly exchangeAuthCodeFn = httpsCallable<ExchangeAuthCodeFnReq, ExchangeAuthCodeFnRes>(
    this.functions,
    'exchangeAuthCode',
  );

  constructor(
    private readonly clientId: string,
    private readonly functions: Functions,
    private readonly redirectUri: string,
    private readonly redirectUriPopup: string,
  ) {}

  public async execute(
    code: string,
    verifier: string,
    isPopup: boolean,
  ): Promise<CredentialEntity> {
    const res = await this.exchangeAuthCodeFn({
      provider: ServiceProvider.Google,
      clientId: this.clientId,
      clientType: ClientType.Web,
      redirectUri: isPopup ? this.redirectUriPopup : this.redirectUri,
      code,
      verifier,
    });

    return res.data.credential;
  }
}
